import React, { useState } from 'react';
import './NonDeviceEdit.css';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import NonDeviceEdit from './NonDeviceEdit';
import NON_DEVICES from '../../constants/NonDevices';
import DEFAULT_NON_DEVICE_GUI from '../../constants/DefaultNonDeviceGUI';

const NonDeviceList = () => {
  const [ editedId, setEditedId ] = useState(null);

  const switchEditNonDevice = id => {
    setEditedId(id);
  };

  const renderNonDevice = nonDevice => {
    return (
      <tr key={nonDevice.id}>
        <td>{nonDevice.label}</td>
        <td className="text-right">
          <a onClick={() => switchEditNonDevice(nonDevice.id)}
            className="btn btn-default btn-action">
            <i className="fa fa-pencil"/>
          </a>
        </td>
      </tr>
    );
  };
  return (
    <Panel eventKey={'nonDevices'}>
      <Panel.Heading>
        <Panel.Title toggle className="btn-simple">
          <i className="fa fa-angle-down"/>
          Controls
        </Panel.Title>
      </Panel.Heading>
      <Panel.Body collapsible>
        {editedId
          ? <NonDeviceEdit id={editedId} onClose={() => setEditedId(null)} onSave={() => setEditedId(null)}/>
          : (
            <Table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th/>
                </tr>
              </thead>
              <tbody>{NON_DEVICES.map(d => renderNonDevice({ ...DEFAULT_NON_DEVICE_GUI[d.id], ...d }))}</tbody>
            </Table>
          )
        }
      </Panel.Body>
    </Panel>
  );
};

export default NonDeviceList;
